import React, { Component, Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import { Map, List } from 'immutable';
import { Flex, Box } from 'grid-styled';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import ProductCard from './ProductCard';
import ProductSplashCard from './ProductSplashCard';
import { analyticsImpressionEvent } from '../util/analyticEvents';

class ProductList extends Component {
  constructor(props) {
    super(props);
    this.renderProductCards = this.renderProductCards.bind(this);
  }

  componentDidMount() {
    analyticsImpressionEvent('productList', false, this.props.data);
  }

  renderProductCards() {
    const { informationCard, modified, viewstate } = this.props;
    const responsiveGridArrayFour = [1 / 2, 1 / 2, 1 / 3, 1 / 4];
    const responsiveGridArraySix = [1 / 3, 1 / 4, 1 / 5, 1 / 6];
    const hasFourInGrid = this.props.columns === 4;
    const hasSixInGrid = this.props.columns === 6;
    const gridPadding = ['5px', '7px', '10px'];
    let currentPosition = 0;

    return this.props.data
      .map((item, index) => {
        currentPosition += 1;
        if (currentPosition === 7 && !informationCard.isEmpty() && !modified && !viewstate.get('pagination')) {
          return (
            <Fragment key={`productCard-${item.get('id')}`}>
              <Box key={index} width={[1, 1, 2 / 3, 2 / 4]} px={gridPadding} my={gridPadding}>
                <ProductSplashCard
                  title={informationCard.get('title')}
                  body={informationCard.get('introduction')}
                  link={informationCard.get('readMoreLink')}
                  images={informationCard.get('image')}
                />
              </Box>
              <Box
                key={`productCard-${item.get('id')}`}
                width={hasFourInGrid ? responsiveGridArrayFour : 1 / 2}
                px={gridPadding}
                my={gridPadding}
              >
                <ProductCard
                  item={item}
                  showVariantImage={this.props.includeRelevance}
                  onProductCardHover={this.props.onProductCardHover}
                />
              </Box>
            </Fragment>
          );
        }

        let width;
        if (hasFourInGrid) {
          width = responsiveGridArrayFour;
        } else if (hasSixInGrid) {
          width = responsiveGridArraySix;
        } else {
          width = 1 / 2;
        }

        return (
          <Box key={`productCard-${item.get('id')}`} width={width} px={gridPadding} my={gridPadding}>
            <ProductCard
              item={item}
              showVariantImage={this.props.includeRelevance}
              activeFilterColor={this.props.activeFilterColor}
              onProductCardHover={this.props.onProductCardHover}
              simpleProductCard={hasSixInGrid}
            />
          </Box>
        );
      })
      .toArray();
  }

  render() {
    const negativeGridPadding = ['-5px', '-7px', '-10px'];

    const productData = this.renderProductCards();

    return (
      <ThemeProvider
        theme={{
          breakpoints: ['40em', '53.125em', '68.75em']
        }}
      >
        <Flex flexWrap="wrap" mx={negativeGridPadding} justifyContent={this.props.center && 'center'}>
          {productData}
        </Flex>
      </ThemeProvider>
    );
  }
}

ProductList.defaultProps = {
  columns: 4,
  center: false,
  modified: false,
  onProductCardHover: null,
  includeRelevance: false,
  informationCard: Map(),
  activeFilterColor: null
};

ProductList.propTypes = {
  columns: PropTypes.number,
  center: PropTypes.bool,
  viewstate: PropTypes.instanceOf(Map).isRequired,
  modified: PropTypes.bool,
  onProductCardHover: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.instanceOf(List)]).isRequired,
  includeRelevance: PropTypes.bool,
  informationCard: PropTypes.instanceOf(Map),
  activeFilterColor: PropTypes.string
};

export default connect(ProductList, {}, store => ({
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/ProductList.js